/** Build drawer state from API candidate row. */
export function buildLiveDetailDrawer(candidate, scoreDate) {
  return {
    type: 'live',
    ticker: candidate.ticker,
    company_name: candidate.company_name,
    score_date: candidate.score_date || scoreDate || null,
    score: candidate.breakout_score,
    signal: candidate.signal,
    signal_label: candidate.signal_label,
    signal_strength: candidate.signal_strength,
    trigger_type: candidate.trigger_type,
    trigger_type_label: candidate.trigger_type_label,
    market_regime: candidate.market_regime,
    market_regime_label: candidate.market_regime_label,
    sector: candidate.sector,
    reasons: candidate.reasons || [],
    price: candidate.price || {},
    smart_money: candidate.smart_money || {},
    trade_plan: candidate.trade_plan || null,
    components: candidate.components || null,
    liquidity: candidate.liquidity || null,
    sector_metrics: candidate.sector_metrics || null,
    strength: candidate.strength || null,
    prep_zone: candidate.prep_zone,
    investor_guidance: candidate.investor_guidance || null,
  };
}

export function buildHistoryDetailDrawer(pick, historyRow) {
  return {
    type: 'history',
    ticker: pick.ticker,
    company_name: pick.company_name,
    score_date: historyRow.score_date,
    score: pick.score ?? pick.breakout_score,
    signal: pick.signal,
    signal_label: pick.signal_label,
    trigger_type: pick.trigger_type,
    trigger_type_label: pick.trigger_type_label,
    market_regime: pick.market_regime,
    market_regime_label: pick.market_regime_label,
    sector: pick.sector,
    price: pick.price || {},
    smart_money: pick.smart_money || {},
    reasons: pick.reasons || [],
    trade_plan: pick.trade_plan || null,
    components: pick.components || null,
    liquidity: pick.liquidity || null,
    sector_metrics: pick.sector_metrics || null,
    strength: pick.strength || null,
    fwd_ret_5d: pick.fwd_ret_5d,
    fwd_ret_10d: pick.fwd_ret_10d,
    day_summary: historyRow,
    loadingDetail: true,
  };
}

export function mergeHistoryDetailDrawer(prev, pick, historyRow, full) {
  if (!prev || prev.ticker !== pick.ticker || prev.score_date !== historyRow.score_date) {
    return prev;
  }
  return {
    ...prev,
    company_name: full.company_name ?? prev.company_name,
    score: full.breakout_score ?? prev.score,
    signal: full.signal ?? prev.signal,
    signal_label: full.signal_label ?? prev.signal_label,
    signal_strength: full.signal_strength,
    trigger_type: full.trigger_type ?? prev.trigger_type,
    trigger_type_label: full.trigger_type_label ?? prev.trigger_type_label,
    market_regime: full.market_regime ?? prev.market_regime,
    market_regime_label: full.market_regime_label ?? prev.market_regime_label,
    sector: full.sector ?? prev.sector,
    reasons: full.reasons || [],
    price: full.price || {},
    smart_money: full.smart_money || {},
    trade_plan: full.trade_plan || null,
    components: full.components || null,
    liquidity: full.liquidity || null,
    sector_metrics: full.sector_metrics || null,
    strength: full.strength ?? null,
    prep_zone: full.prep_zone ?? prev.prep_zone,
    investor_guidance: full.investor_guidance ?? prev.investor_guidance,
    loadingDetail: false,
  };
}
